<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M1.16675 13.9993C1.16675 17.403 2.51883 20.6672 4.92554 23.0739C7.33226 25.4806 10.5965 26.8327 14.0001 26.8327C17.4037 26.8327 20.6679 25.4806 23.0746 23.0739C25.4813 20.6672 26.8334 17.403 26.8334 13.9993C26.8334 10.5957 25.4813 7.33153 23.0746 4.92481C20.6679 2.5181 17.4037 1.16602 14.0001 1.16602C10.5965 1.16602 7.33226 2.5181 4.92554 4.92481C2.51883 7.33153 1.16675 10.5957 1.16675 13.9993Z" fill="#2BCAB2"/>
        <path d="M19.8333 10.5L13.5333 17.5L9.33325 14" stroke="#1A2653" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>
<script>
const addedIcon = {
    name: 'addedIcon',
    props: {
    }
}
export default addedIcon
export { addedIcon }
</script>